import VirtualTourImage from "../assets/virtualtour.svg";
import ReinovaButton from "./ReinovaButton";

export default function VirtualTourButton() {
    return <ReinovaButton
        onClick={() => window.open("https://cms.coperniko.com/tour/reinova/239/virtual-tour")}
        
        style={{
            borderRadius: '50%',
            minWidth: 90,
            width: 90,
            height: 90,
            padding: 0,
            overflow: 'hidden',
            position: 'relative',
            border: 'none', // Remove the default solid border
            // We create the gradient using a pseudo-element
            '&::before': {
                content: '""',
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                borderRadius: '50%',
                padding: '3px', // This is your border thickness
                background: 'linear-gradient(90deg, #81BC00, #705B95)',
                WebkitMask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
                WebkitMaskComposite: 'destination-out',
                maskComposite: 'exclude',
            }
        } as any}
        >
            <img 
                src={VirtualTourImage}
                alt="profile" 
                style={{ 
                width: '100%', 
                height: '100%', 
                borderRadius: '50%', 
                objectFit: 'cover',
                display: 'block'
                }} 
            />
        </ReinovaButton>
}